// extracted by mini-css-extract-plugin
export default {"imageSwiper":"image-swiper-module--image-swiper--f4186"};